// frontend/src/components/PostPatrocinio.jsx
import React, { useState, useEffect, useImperativeHandle, forwardRef } from 'react';
import './PostPatrocinio.css';

const PostPatrocinio = forwardRef(({ postData, onUpdate, canEdit, onEditingChange }, ref) => {
  const [isEditing, setIsEditing] = useState(false);
  const [formData, setFormData] = useState({
    post_patrocinado: false,
    patrocinio_centro_costo: '',
    patrocinio_link: '',
    patrocinio_codigo: '',
    patrocinio_monto: ''
  });

  const setEditing = (val) => {
    setIsEditing(val);
    onEditingChange?.(val);
  };

  useEffect(() => {
    if (postData) {
      setFormData({
        post_patrocinado: postData.post_patrocinado || false,
        patrocinio_centro_costo: postData.patrocinio_centro_costo || '',
        patrocinio_link: postData.patrocinio_link || '',
        patrocinio_codigo: postData.patrocinio_codigo || '',
        patrocinio_monto: postData.patrocinio_monto || ''
      });
    }
  }, [postData]);

  const handleInputChange = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }));
  };

  const handleSave = () => {
    if (onUpdate) onUpdate(formData);
    setEditing(false);
  };

  const handleCancel = () => {
    setFormData({
      post_patrocinado: postData.post_patrocinado || false,
      patrocinio_centro_costo: postData.patrocinio_centro_costo || '',
      patrocinio_link: postData.patrocinio_link || '',
      patrocinio_codigo: postData.patrocinio_codigo || '',
      patrocinio_monto: postData.patrocinio_monto || ''
    });
    setEditing(false);
  };

  useImperativeHandle(ref, () => ({
    triggerSave: handleSave,
    triggerCancel: handleCancel,
  }));

  if (!postData) return null;

  return (
    <div className="post-patrocinio">
    <div className="patrocinio-card">

      {/* ── Header ── */}
      <div className="patrocinio-header">
        <h3>Información de Patrocinio</h3>
        {canEdit && !isEditing && (
          <button className="cal-icon-btn" onClick={() => setEditing(true)} title="Editar">
            <i className="bi bi-pencil" />
          </button>
        )}
      </div>

      {/* ── Checkbox patrocinado ── */}
      <div className={`patrocinio-toggle${formData.post_patrocinado ? ' is-sponsored' : ''}`}>
        <label className="patrocinio-toggle-label">
          <input
            type="checkbox"
            checked={formData.post_patrocinado}
            onChange={(e) => handleInputChange('post_patrocinado', e.target.checked)}
            disabled={!isEditing}
          />
          <span>Post Patrocinado</span>
        </label>
      </div>

      {/* ── Campos de patrocinio (solo si está marcado) ── */}
      {formData.post_patrocinado && (
        <div className="info-grid">

          {/* Centro de Costo */}
          <div className={`info-item${isEditing ? ' info-item--edit' : ''}`}>
            <label>Centro de Costo</label>
            {isEditing ? (
              <input
                className="info-edit-field"
                type="text"
                value={formData.patrocinio_centro_costo}
                onChange={(e) => handleInputChange('patrocinio_centro_costo', e.target.value)}
                placeholder="Ej: CC-2024-001"
                maxLength={200}
              />
            ) : (
              <span>{formData.patrocinio_centro_costo || 'N/A'}</span>
            )}
          </div>

          {/* Código de Patrocinio */}
          <div className={`info-item${isEditing ? ' info-item--edit' : ''}`}>
            <label>Código de Patrocinio</label>
            {isEditing ? (
              <input
                className="info-edit-field"
                type="text"
                value={formData.patrocinio_codigo}
                onChange={(e) => handleInputChange('patrocinio_codigo', e.target.value)}
                placeholder="Ej: PAT2024ABC"
                maxLength={100}
              />
            ) : (
              <span>{formData.patrocinio_codigo || 'N/A'}</span>
            )}
          </div>

          {/* Monto del Patrocinio */}
          <div className={`info-item${isEditing ? ' info-item--edit' : ''}`}>
            <label>Monto del Patrocinio</label>
            {isEditing ? (
              <input
                className="info-edit-field"
                type="number"
                step="0.01"
                min="0"
                value={formData.patrocinio_monto}
                onChange={(e) => handleInputChange('patrocinio_monto', e.target.value)}
                placeholder="0.00"
              />
            ) : (
              <span>
                {formData.patrocinio_monto
                  ? `$${parseFloat(formData.patrocinio_monto).toLocaleString('es-CL', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
                  : 'N/A'}
              </span>
            )}
          </div>

          {/* Link de Patrocinio */}
          <div className={`info-item${isEditing ? ' info-item--edit' : ''}`}>
            <label>Link de Patrocinio</label>
            {isEditing ? (
              <input
                className="info-edit-field"
                type="url"
                value={formData.patrocinio_link}
                onChange={(e) => handleInputChange('patrocinio_link', e.target.value)}
                placeholder="https://ejemplo.com/patrocinio"
                maxLength={500}
              />
            ) : (
              <span>
                {formData.patrocinio_link ? (
                  <a href={formData.patrocinio_link} target="_blank" rel="noopener noreferrer"
                    style={{ color: '#2563eb', textDecoration: 'none' }}>
                    {formData.patrocinio_link}
                  </a>
                ) : 'N/A'}
              </span>
            )}
          </div>

        </div>
      )}

      {/* ── Mensaje vacío ── */}
      {!formData.post_patrocinado && !isEditing && (
        <p className="patrocinio-empty">Este post no está marcado como patrocinado.</p>
      )}

      {/* Guardar / Cancelar movidos al footer del modal padre */}

    </div>
    </div>
  );
});

export default PostPatrocinio;
